<nz-card class="model-card">
    <section class="top-section">
        <div class="form-column">
            <div class="iterations-row">
                <div class="des-box blue">
                    <div class="des-icon">
                        <img src="/assets/icons/costs/icon02.png" alt="" />
                    </div>
                    <div class="des-detail">
                        <h3>Iterations</h3>
                        <p>{{ jobStateService.iteration() }} / {{ currentJob().iterations }}</p>
                    </div>
                </div>
                <div>
                    @if(jobStateService.jobData(); as data){
                        <span class="custom-badge"
                            nz-tooltip
                            [nzTooltipTitle]="jobTypeTooltip"
                            [style.background-color]="TYPE_COLORS[data.type]">
                            {{ data.type }}
                        </span>
                    }
                </div>
            </div>

            <div #targetElement class="form-container">
                @if (!jobStateService.jobData().modelGrid.is2d){
                <div class="form-label">Inline</div>
                <div class="form-field">
                    <app-job-slider [isMobile]="isMobile" label="Inline" [upperLimit]="maxInline()" [lowerLimit]="1"
                        [value]="jobStateService.inline()" (valueUpdated)="jobStateService.inline.set($event); nullifyLog()" />
                </div>

                <div class="form-label">Crossline</div>
                <div class="form-field">
                    <app-job-slider [isMobile]="isMobile" label="Crossline" [upperLimit]="maxCrossline()" [lowerLimit]="1"
                        [value]="jobStateService.crossline()" (valueUpdated)="jobStateService.crossline.set($event); nullifyLog()" />
                </div>

                <div class="form-label">Depth</div>
                <div class="form-field">
                    <app-job-slider [isMobile]="isMobile" label="Depth" [upperLimit]="maxDepth()" [lowerLimit]="1"
                        [value]="jobStateService.depth()" (valueUpdated)="jobStateService.depth.set($event)" />
                </div>
                }
                <div class="form-label">Iterations</div>
                <div class="form-field">
                    <app-job-slider [isMobile]="isMobile" label="Iterations" [upperLimit]="maxIterations()"
                        [value]="jobStateService.iteration()" (valueUpdated)="jobStateService.iteration.set($event)" />
                </div>
            </div>
        </div>
        <div class="functionals-container">
            @if(currentJob().type == 'QC'){
            <nz-alert nzType="info" nzMessage="QC Job"
                nzDescription="QC jobs do not have applicable functional sequences. If this is not a QC job, please verify that the naming convention has been followed."
                nzShowIcon />
            } @else {
            @if (jobStateService.functionalTableResource.isLoading()) {
            <div class="spinner-wrapper">
                <nz-spin nzSimple nzTip="Loading functional data..."></nz-spin>
            </div>
            } @else if (jobStateService.functionalTableResource.error(); as error) {
            <nz-alert nzType="error" nzMessage="Failed to load functional data" [nzDescription]="error"></nz-alert>
            } @else if (jobStateService.functionalTableResource.value(); as data) {
            <nz-table #functionalTable [nzData]="data" nzSize="small" id="functionals-table" class="styled-table"
                [nzScroll]="{ y: '200px' }" [nzFrontPagination]="false" [nzShowPagination]="false"
            >
                <thead>
                    <tr>
                        <th nzWidth="60px">Block</th>
                        <th>Functional</th>
                        <th nzWidth="90px">Frequency</th>
                        <th>Iterations</th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of functionalTable.data; track item.block) {
                    <tr [class.block-inactive]="!item.block_started">
                        <td [ngClass]="item.functional + ' block'"
                            [style.border-left-color]="FUNCTIONAL_COLORS[item.functional]">
                            {{ item["block"] }}
                        </td>
                        <td>{{ item["functional"] }}
                            @if(item['functional'] == 'AWI'){
                            <b class="additionals-tag">
                                {{item['additionals']}}
                            </b>
                            }
                        </td>
                        <td>{{ item["frequency"]?.toFixed(2) ?? 'None' }}</td>
                        <td>
                            {{item["iterations"]}}
                            @if(item['functional'] == 'RWI'){
                            <b class="additionals-tag">
                                {{item['additionals']}}
                            </b>
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </nz-table>
            }
            }
        </div>
    </section>
    <div class="comment-bar">
        <span nz-icon nzType="message" nzTheme="outline" class="comment-icon"></span>
        @if (!commentEditing()) {
            <div class="comment-display" (click)="startCommentEdit()" nz-tooltip nzTooltipTitle="Click to edit comment">
                @if (comments()) {
                    <span class="comment-text">{{ comments() }}</span>
                } @else {
                    <span class="comment-placeholder">Add a comment…</span>
                }
                <span nz-icon nzType="edit" nzTheme="outline" class="comment-edit-icon"></span>
            </div>
        } @else {
            <div class="comment-editor">
                <textarea #commentInput nz-input [ngModel]="comments()" (ngModelChange)="comments.set($event)"
                    rows="3" placeholder="Add a comment for this model..."
                    (keydown.control.enter)="saveComment()" (keydown.meta.enter)="saveComment()"
                    (keydown.escape)="cancelCommentEdit()"></textarea>
                <div class="comment-actions">
                    @if (commentDirty()) {
                        <span class="comment-unsaved-hint">Unsaved</span>
                    }
                    <button nz-button nzSize="small" (click)="cancelCommentEdit()" [disabled]="commentSaving()">Cancel</button>
                    <button nz-button nzType="primary" nzSize="small" (click)="saveComment()"
                        [disabled]="!commentDirty()" [nzLoading]="commentSaving()">Save</button>
                </div>
            </div>
        }
    </div>
</nz-card>

<div class="scroll-to-button-group">
    @if (viewerSettings.showDepthSlice()) {
        <button (click)="scrollToAnchor('depth-slice')" nz-button>Scroll
        to Depth</button>
    }
    @if (viewerSettings.fullWidthIlXl() || viewerSettings.verticalProfileMode() === 'besideInline') {
        <button (click)="scrollToAnchor('crossline-slice')" nz-button
        >Scroll to XL</button>
    }
    @if (!jobStateService.jobData().modelGrid.is2d){
        <button (click)="scrollToAnchor('inline-slice')" nz-button >Scroll to IL</button>
    }
</div>
<app-settings-box />

@if(!jobStateService.jobData().modelGrid.is2d){
<div class="viewer-grid" #ssDiv id="ss-div" [class.full-width-mode]="viewerSettings.fullWidthIlXl()"
    [class.profile-beside-inline]="viewerSettings.verticalProfileMode() === 'besideInline'">

    <div id="inline-slice" class="slice-container" [style.width.px]="(viewerSettings.fullWidthIlXl() || viewerSettings.verticalProfileMode() === 'besideInline') ? null : widthIL">
        <app-inline-slice (onScreenshot)="onScreenshotHandler($event)" />
    </div>

    <div id="crossline-slice" class="slice-container" [style.width.px]="(viewerSettings.fullWidthIlXl() || viewerSettings.verticalProfileMode() === 'besideInline') ? null : widthXL">
        <app-crossline-slice />
    </div>

    @if(viewerSettings.showDepthSlice()){
    <div id="depth-slice" class="slice-container">
        <app-depth-slice />
    </div>
    }

    @if(viewerSettings.verticalProfileMode() !== 'hide'){
    <div id="v-profile" class="slice-container">
        <app-vertical-profile />
    </div>
    }

</div>}
@else {
<div class="viewer-grid-2d" #ssDiv id="ss-div" [class.no-profile]="viewerSettings.verticalProfileMode() === 'hide'">
    <div id="inline-slice" class="slice-container">
        <app-inline-slice (onScreenshot)="onScreenshotHandler()" />
    </div>
    @if(viewerSettings.verticalProfileMode() !== 'hide'){
    <div id="v-profile" class="slice-container">
        <app-vertical-profile />
    </div>
    }
</div>
}


<div id="alternate-bottom-bar" [class.is-visible]="isAlternateVisible() && !(isMobile && isLandscape)" [style.bottom.px]="bottomTabsHeight()">
    <div class="bottom-form-container">
        <div class="form-label">Iterations</div>
        <div class="form-field">
            <app-job-slider label="Iterations" [upperLimit]="maxIterations()"
                [value]="jobStateService.iteration()" (valueUpdated)="jobStateService.iteration.set($event)" />
        </div>
        @if (!jobStateService.jobData().modelGrid.is2d){
        <div class="form-label">Inline</div>
        <div class="form-field">
            <app-job-slider label="Inline" [upperLimit]="maxInline()" [lowerLimit]="1"
            [value]="jobStateService.inline()" (valueUpdated)="jobStateService.inline.set($event); nullifyLog()" />
        </div>

        <div class="form-label">Crossline</div>
        <div class="form-field">
            <app-job-slider label="Crossline" [upperLimit]="maxCrossline()" [lowerLimit]="1"
                [value]="jobStateService.crossline()" (valueUpdated)="jobStateService.crossline.set($event); nullifyLog()" />
        </div>

        <div class="form-label">Depth</div>
        <div class="form-field">
            <app-job-slider label="Depth" [upperLimit]="maxDepth()" [lowerLimit]="1"
                [value]="jobStateService.depth()" (valueUpdated)="jobStateService.depth.set($event)" />
        </div>
        }
    </div>
</div>

<ng-template #jobTypeTooltip>
    <div>
        @for(item of TYPE_COLORS | keyvalue; track item){
            <div class="job-type-row">
                <span class="job-type-marker" [style.backgroundColor]="item.value"></span>
                {{item.key}}
            </div>
        }
    </div>
</ng-template>

